























import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Big from 'big.js'

@Component({
    components: {},
})
export default class AVAXBalanceTableSummary extends Vue {
    balances: any[] = [
        {
            name: 'Locked',
            balance: this.totalAVAXLocked,
        },
        {
            name: 'Unlocked',
            balance: this.totalAVAXUnlocked,
        },
        {
            name: 'Staked',
            balance: this.totalAVAXStaked,
        },
        {
            name: 'Total Balance',
            balance: this.totalAVAX,
        },
    ]

    @Prop() pUnlocked!: Big
    @Prop() pLockedStakeable!: Big
    @Prop() pLockedNotStakeable!: Big
    @Prop() pStaked!: Big
    @Prop() xpUnlocked!: Big
    @Prop() xUnlocked!: Big
    @Prop() xLocked!: Big
    @Prop() xcUnlocked!: Big

    get totalAVAXStaked(): Big {
        return this.pStaked
    }

    get totalAVAXLocked(): Big {
        return this.pLockedStakeable
            .plus(this.pLockedNotStakeable)
            .plus(this.xLocked)
    }

    get totalAVAXUnlocked(): Big {
        return this.pUnlocked
            .plus(this.xpUnlocked)
            .plus(this.xUnlocked)
            .plus(this.xcUnlocked)
    }

    get totalAVAX(): Big {
        return this.pUnlocked
            .plus(this.pLockedStakeable)
            .plus(this.pLockedNotStakeable)
            .plus(this.pStaked)
            .plus(this.xpUnlocked)
            .plus(this.xUnlocked)
            .plus(this.xLocked)
            .plus(this.xcUnlocked)
    }
}
